import { useEffect, useState } from "react";
import { Download, Printer, Loader2, FileText } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const KINDS = [{ k: "internal", label: "Internal Costing" }, { k: "quote", label: "Draft Penawaran" }];

export const CostingPdfPreview = ({ costing, open, onOpenChange }) => {
  const [kind, setKind] = useState("internal");
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!open || !costing?.id) return undefined;
    let u = "";
    setUrl("");
    api.get(`/costings/${costing.id}/pdf`, { params: { kind }, responseType: "blob" })
      .then((r) => { u = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" })); setUrl(u); })
      .catch((e) => toast.error(errMsg(e)));
    return () => u && URL.revokeObjectURL(u);
  }, [open, kind, costing?.id, costing?.updated_at]);
  const name = `${kind === "quote" ? "DRAFT-QUOTATION" : "KALKULASI"}-${(costing?.costing_no || "").replace(/[^A-Za-z0-9_-]+/g, "-")}.pdf`;
  const dl = () => { const a = document.createElement("a"); a.href = url; a.download = name; a.click(); };
  const print = () => { const w = window.open(url, "_blank"); w?.addEventListener("load", () => w.print()); };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={undefined} className="flex h-[92vh] w-[95vw] max-w-6xl flex-col">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><FileText className="h-5 w-5 text-blue-800" />Preview PDF {costing?.costing_no}</DialogTitle></DialogHeader>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div className="flex rounded-lg border border-slate-200 bg-slate-50 p-1">
            {KINDS.map((o) => (
              <button key={o.k} type="button" onClick={() => setKind(o.k)} className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${kind === o.k ? "bg-blue-800 text-white" : "text-slate-600 hover:bg-white"}`} data-testid={`pdf-kind-${o.k}`}>{o.label}</button>
            ))}
          </div>
          <div className="flex gap-2">
            <Button variant="outline" className="bg-white" disabled={!url} onClick={print} data-testid="pdf-print-btn"><Printer className="h-4 w-4 mr-1" />Print</Button>
            <Button disabled={!url} onClick={dl} data-testid="pdf-download-btn"><Download className="h-4 w-4 mr-1" />Download</Button>
          </div>
        </div>
        <div className="min-h-0 flex-1 overflow-hidden rounded-lg border border-slate-200 bg-slate-100">
          {url ? <iframe title="preview" src={url} className="h-full w-full" data-testid="pdf-preview-frame" /> : <div className="flex h-full items-center justify-center text-slate-400"><Loader2 className="h-6 w-6 animate-spin" /></div>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
